import React from 'react';

export default function CourseHeader({ title }) {
	return (
		<div className="mb-4 flex justify-between items-center px-4 pt-4">
			<div>
				<h1 className="text-xl">{title || "Course Content"}</h1>
			</div>
		</div>
	);
}
